import RevolvingFundsError from './RevolvingFundsError';
class PropertyIsNotRegistered extends RevolvingFundsError {
    propertyId;
    constructor(propertyId, options) {
        super('Property ID not registered for revolving funds', options);
        this.propertyId = propertyId;
    }
}
export default PropertyIsNotRegistered;
